module.exports = __webpack_public_path__ + "img/pdf.1cda07bb.png";